//--------------------------------------------------------------
// Event Viewer Modal
//--------------------------------------------------------------
export const EVENT_VIEWER_MODAL_SHOW = 'EVENT_VIEWER_MODAL_SHOW';
export const EVENT_VIEWER_MODAL_HIDE = 'EVENT_VIEWER_MODAL_HIDE';
export const EVENT_MATCHES_EDIT_MODAL_SHOW = 'EVENT_MATCHES_EDIT_MODAL_SHOW';
export const EVENT_MATCHES_EDIT_MODAL_HIDE = 'EVENT_MATCHES_EDIT_MODAL_HIDE';

//--------------------------------------------------------------
// Event Filtering
//--------------------------------------------------------------
export const SET_FILTER = 'SET_FILTER';
export const SET_FILTER_PARTIAL = 'SET_FILTER_PARTIAL';
export const SET_FILTER_DEFAULT = 'SET_FILTER_DEFAULT';
export const SET_FILTER_CLEAN = 'SET_FILTER_CLEAN';
export const COLLAPSE_ALL = 'COLLAPSE_ALL';

//--------------------------------------------------------------
// AUTH
//--------------------------------------------------------------
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const ALLOW_CHANGE_PASSWORD = 'ALLOW_CHANGE_PASSWORD';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

//--------------------------------------------------------------
// Fleet actions
//--------------------------------------------------------------
export const FLEET_LOADED = 'FLEET_LOADED';
export const SET_FLEET_OVERRIDE = 'SET_FLEET_OVERRIDE';

//--------------------------------------------------------------
// Timezone
//--------------------------------------------------------------
export const SET_TIMEZONE = 'SET_TIMEZONE';

//--------------------------------------------------------------
// Device management
//--------------------------------------------------------------
export const DEVICE_TABLE_UPDATE_GROUPING = 'DEVICE_TABLE_UPDATE_GROUPING';

//--------------------------------------------------------------
// Route editor
//--------------------------------------------------------------

export const ROUTE_EDITOR_ADD_GROUP = 'ROUTE_EDITOR_ADD_GROUP';
export const ROUTE_EDITOR_SET_GROUPS = 'ROUTE_EDITOR_SET_GROUPS';
export const ROUTE_EDITOR_REMOVE_GROUP = 'ROUTE_EDITOR_REMOVE_GROUP';
export const ROUTE_EDITOR_RENAME_GROUP = 'ROUTE_EDITOR_RENAME_GROUP';
export const ROUTE_EDITOR_TOGGLE_GROUP_VISIBILITY = 'ROUTE_EDITOR_TOGGLE_GROUP_VISIBILITY';

export const ROUTE_EDITOR_SELECT_GROUP = 'ROUTE_EDITOR_SELECT_GROUP';
export const ROUTE_EDITOR_SELECT_FEATURE = 'ROUTE_EDITOR_SELECT_FEATURE';
export const ROUTE_EDITOR_KEY_PRESSED = 'ROUTE_EDITOR_KEY_PRESSED';
export const ROUTE_EDITOR_KEY_RELEASED = 'ROUTE_EDITOR_KEY_RELEASED';

export const ROUTE_EDITOR_UPDATE_FEATURE_PROPERTIES = 'ROUTE_EDITOR_PROPAGATE_PROPERTIES_TO_FEATURES';
export const ROUTE_EDITOR_UPDATE_ANNOTATOR_DATA = 'ROUTE_EDITOR_SET_ANNOTATOR_DATA';
export const ROUTE_EDITOR_SET_MAP = 'ROUTE_EDITOR_SET_MAP';
export const ROUTE_EDITOR_ADD_FEATURE = 'ROUTE_EDITOR_ADD_FEATURE';
export const ROUTE_EDITOR_FEATURE_GEOMETRY_UPDATE = 'ROUTE_EDITOR_FEATURE_GEOMETRY_UPDATE';
export const ROUTE_EDITOR_REMOVE_SELECTED_FEATURES = 'ROUTE_EDITOR_REMOVE_SELECTED_FEATURES';
export const ROUTE_EDITOR_GROUP_SELECTED_FEATURES = 'ROUTE_EDITOR_GROUP_SELECTED_FEATURES';
export const ROUTE_EDITOR_UNGROUP_SELECTED_GROUP = 'ROUTE_EDITOR_UNGROUP_SELECTED_GROUP';
export const ROUTE_EDITOR_UNGROUP_SELECTED_FEATURES = 'ROUTE_EDITOR_UNGROUP_SELECTED_FEATURES';
export const ROUTE_EDITOR_ADD_SELECTED_FEATURES_TO_GROUP = 'ROUTE_EDITOR_ADD_SELECTED_FEATURES_TO_GROUP';
export const ROUTE_EDITOR_import = 'ROUTE_EDITOR_import';
export const ROUTE_EDITOR_MOVE_TO = 'ROUTE_EDITOR_MOVE_TO';
export const ROUTE_EDITOR_HIDE_MOVE_TO_POINT = 'ROUTE_EDITOR_HIDE_MOVE_TO_POINT';
export const ROUTE_EDITOR_OPEN_GROUP_CONTENT_OVERVIEW = 'ROUTE_EDITOR_OPEN_GROUP_LINES_OVERVIEW';
export const ROUTE_EDITOR_OPEN_ALL_CONTENT_OVERVIEW = 'ROUTE_EDITOR_OPEN_ALL_LINES_OVERVIEW';
export const ROUTE_EDITOR_CLOSE_CONTENT_OVERVIEW = 'ROUTE_EDITOR_CLOSE_ALL_LINES_OVERVIEW';
export const ROUTE_EDITOR_REMOVE_FEATURE = 'ROUTE_EDITOR_REMOVE_FEATURE';
export const ROUTE_EDITOR_DUPLICATE_SELECTED_FEATURES = 'ROUTE_EDITOR_DUPLICATE_FEATURE';
export const ROUTE_EDITOR_FEATURE_MOUSE_OVER = 'ROUTE_EDITOR_FEATURE_MOUSE_OVER';
export const ROUTE_EDITOR_FEATURE_MOUSE_OUT = 'ROUTE_EDITOR_FEATURE_MOUSE_OUT';
